function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M38 60.6587C38.5523 60.6587 39 60.211 39 59.6587C39 59.1064 38.5523 58.6587 38 58.6587V60.6587ZM6 19.6587L0.226497 29.6587H11.7735L6 19.6587ZM38 58.6587H10V60.6587H38V58.6587ZM7 55.6587V28.6587H5V55.6587H7ZM10 58.6587C8.34315 58.6587 7 57.3155 7 55.6587H5C5 58.4201 7.23858 60.6587 10 60.6587V58.6587Z",
  fill: "#9F9A98"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24 2.65869C23.4477 2.65869 23 3.10641 23 3.65869C23 4.21098 23.4477 4.65869 24 4.65869V2.65869ZM56.5 42.6587L62.2735 32.6587H50.7265L56.5 42.6587ZM24 4.65869H52.5V2.65869H24V4.65869ZM55.5 7.65869V33.6587H57.5V7.65869H55.5ZM52.5 4.65869C54.1569 4.65869 55.5 6.00184 55.5 7.65869H57.5C57.5 4.89727 55.2614 2.65869 52.5 2.65869V4.65869Z",
  fill: "#3C3C3B"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 53,
  y: 54.6587,
  width: 6,
  height: 6,
  rx: 3,
  stroke: "#9F9A98",
  strokeWidth: 2
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  x: 3,
  y: 1.65869,
  width: 6,
  height: 6,
  rx: 3,
  stroke: "#3C3C3B",
  strokeWidth: 2
});

var _ref6 =
/*#__PURE__*/
React.createElement("rect", {
  x: 25,
  y: 29.6587,
  width: 12,
  height: 9,
  rx: 1,
  stroke: "#3C3C3B",
  strokeWidth: 2
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34 28.6587V25.6587C34 24.0018 32.6569 22.6587 31 22.6587V22.6587C29.3431 22.6587 28 24.0018 28 25.6587V28.6587",
  stroke: "#3C3C3B",
  strokeWidth: 2
});

var _ref8 =
/*#__PURE__*/
React.createElement("rect", {
  x: 30,
  y: 33.6587,
  width: 2,
  height: 2,
  rx: 1,
  fill: "#3C3C3B"
});

var SvgFeatureOne6 = function SvgFeatureOne6(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFeatureOne6, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FeatureOne-6.30aa1db6.svg";
export { ForwardRef as ReactComponent };